

// $Classes/Enums/Interfaces(filter)[template][separator]
// filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
// template: The template to repeat for each matched item
// separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]

// More info: http://frhagn.github.io/Typewriter/




export enum PtType {
    
        InputDevice = 0,
        InputConfig = 1,
        InputSystem = 2,
        SupportDevice = 3,
        ActionDevice = 4,
        ActionConfig = 5,
        ActionSystem = 6,
        LogicSolver = 7,
        OverallSystem = 8,
        ManualInput = 9,
        ManualInputConfig = 10,
        ManualAction = 11,
        Other = 12,
}